import script from "./CalendarBulkAttendance.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarBulkAttendance.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarBulkAttendance.vue?vue&type=style&index=0&id=5af37e97&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af37e97"]])

export default __exports__